// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { systemBuilderProductInventroyStyles } from "@plumberssupply/App/Components/SystemBuilder/SystemBuilderProductInventroy";
import { color, xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

systemBuilderProductInventroyStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
systemBuilderProductInventroyStyles.messageGridItem = { width: 12 };
systemBuilderProductInventroyStyles.availabilityByWarehouseLinkGridItem = { width: 12 };
systemBuilderProductInventroyStyles.availabilityByWarehouseModal = {
    size: 400,
    cssOverrides: {
        modalTitle: css`
            padding: 18px 18px 15px;
        `,
    },
};
systemBuilderProductInventroyStyles.centeringWrapper = {
    css: css`
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
    `,
};
systemBuilderProductInventroyStyles.spinner = {
    css: css`
        margin: 0 auto;
    `,
};
systemBuilderProductInventroyStyles.messageText = {
    size: 12,
    css: css`
        letter-spacing: 0;
        line-height: 15px;
        white-space: nowrap;
        cursor: pointer;
    `,
};
systemBuilderProductInventroyStyles.availabilityByWarehouseLink = {
    typographyProps: {
        size: 12,
        css: css`
            line-height: 15px;
        `,
    },
    css: css`
        margin-left: 18px;
        @media print {
            display: inline-block !important; // override buttons display: none !important
            margin-left: 0;
        }
    `,
};
systemBuilderProductInventroyStyles.realTimeText = {
    size: 12,
    weight: "bold",
    css: css`
        display: inline-block;
        text-align: left;
        min-width: 25px;

        &::after {
            overflow: hidden;
            display: inline-block;
            vertical-align: bottom;
            animation: ellipsis steps(4, end) 900ms infinite 1s;
            content: "\\2026";
            width: 0;
        }

        @keyframes ellipsis {
            to {
                width: 1.25em;
            }
        }
    `,
};
systemBuilderProductInventroyStyles.errorText = {
    size: 12,
    weight: "bold",
};
systemBuilderProductInventroyStyles.availabilityByWarehouseTable = {
    cssOverrides: {
        header: css`
            width: 50%;
            background: ${color("common.ui11")};
            padding: 8px 12px;
            height: 34px;
            border-bottom: none;
        `,
    },
};
systemBuilderProductInventroyStyles.outOfStock = {
    size: 14,
    lineHeight: "22px",
    color: "common.ui8",
};
systemBuilderProductInventroyStyles.inventoryMessageContent = {
    css: css`
        display: flex;
        ${xScreen("lt", "xs")} {
            flex-wrap: wrap;
        }
    `,
};
systemBuilderProductInventroyStyles.wrapper = {
    css: css`
        line-height: 0;
    `,
};
